import firebase from '../../lib/firebase.prod';
import * as PROJECT_CODE from '../../constants/projectCode';
import * as ORIGINAL_HREF from '../../constants/originalHref';

const firebaseRef = firebase.database();

export default async function viewDocument(
	leadInfo,
	leadId,
	documentType,
	setAlert,
	setLoading
) {
	var currentUserId = firebase.auth().currentUser.uid;

	console.log('viewDocument leadid', leadId);
	var dataJson = {
		keyvalue: leadId,
		name:
			leadInfo.clientInfo.firstName + ' ' + leadInfo.clientInfo.lastName,
		clientemail: leadInfo.clientEmail,
	};

	console.log('viewDocument dataJson', dataJson);

	console.log('Get Client APS Files');

	var jsonData = { clientInfo: dataJson };
	jsonData['thisUserId'] = currentUserId;
	jsonData['projectCode'] = PROJECT_CODE.projectCode;
	jsonData['authToken'] = ORIGINAL_HREF.originalHREF['access_token'];

	if (documentType === 'APS') {
		var getClientDocumentInfo = await firebase
			.functions()
			.httpsCallable('GetClientLatestAPSFiles');

		//https://us-central1-planxr-demo-centre.cloudfunctions.net/GetClientLatestAPSFiles

		var clientFiles;
		await getClientDocumentInfo(jsonData).then((result) => {
			console.log('results: ' + JSON.stringify(result));

			clientFiles = result;
			clientFiles['originalClientEmail'] = leadInfo.clientemail;
		});
	} else if (documentType === 'Condo Docs') {
		var getClientDocumentInfo = await firebase
			.functions()
			.httpsCallable('GetClientLatestCondoDocFiles');

		var clientFiles;
		await getClientDocumentInfo(jsonData).then((result) => {
			console.log('results: ' + JSON.stringify(result));

			clientFiles = result;
			clientFiles['originalClientEmail'] = leadInfo.clientemail;
		});
	} else {
		jsonData['subject'] = documentType;

		var getClientDocumentInfo = await firebase
			.functions()
			.httpsCallable('GetClientFilesBySubject');

		var clientFiles;
		await getClientDocumentInfo(jsonData).then((result) => {
			console.log('extra results: ' + JSON.stringify(result));

			clientFiles = result;
			clientFiles['originalClientEmail'] = leadInfo.clientemail;
		});
	}

	if (clientFiles.data.status === 'complete') {
		console.log('handleAPS pdf', clientFiles.data.pdfPath);
		// setDocLoading(true);

		if (clientFiles.data.pdfPath) {
			firebaseRef
				.ref(clientFiles.data.pdfPath)
				.child('base64pdf')
				.on('value', (snapshot) => {
					//then we view the pdf in here

					console.log('handleAPS in the snapshot', snapshot?.val());
					if (
						snapshot.val() !== undefined &&
						snapshot.val() !== null &&
						snapshot.val()
					) {
						var isReady = snapshot.val();

						if (isReady) {
							window.location = isReady;
							setLoading(false);
						}
					}
				});
		}
	} else if (clientFiles.data.status === 'no_document') {
		setAlert('Document has not been sent yet.');
		setLoading(false);
		// setSnackbar(true);
		// setSnackbarType('warning');
		// setTimeout(() => {
		//     setAlert();
		// }, 4000);
		// setDocLoading(false);
		//still_processing
	} else if (clientFiles.data.status === 'still_processing') {
		setAlert('Document is still processing try again later.');
		setLoading(false);
		// setSnackbar(true);
		// setSnackbarType('warning');
		// setTimeout(() => {
		//     setAlert();
		// }, 4000);
		// setDocLoading(false);
		//still_processing
	}
}
